// แปลง array ของ teachtime ให้ group ตาม teach_id
export function groupTeachingData(rows) {
  const map = {};
  rows.forEach(row => {
    if (!map[row.teach_id]) {
      map[row.teach_id] = {
        ...row,
        times: []
      };
    }
    map[row.teach_id].times.push({
      teach_day: row.teach_day,
      period_id: row.period_id, // ใช้ period_id แทน period_order
      period_order: row.period_order, // ถ้ายังต้องการแสดงลำดับคาบในตาราง ให้เก็บไว้ด้วย
      period_begin: row.period_begin,
      period_end: row.period_end
    });
  });
  // ลบ field ที่ซ้ำใน object หลัก
  return Object.values(map).map(item => {
    delete item.teach_day;
    delete item.period_id;
    delete item.period_order;
    delete item.period_begin;
    delete item.period_end;
    return item;
  });
}

// ฟังก์ชันแปลงเลขวันเป็นชื่อวันภาษาไทย
export function getDayNameTHByIndex(idx) {
  const days = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
  return days[idx] ?? "-";
}

// ฟังก์ชันแปลงข้อมูลวิชาให้กลุ่มตาม teach_id หรือ sub_id
export function groupSubjectData(rows) {
  const map = {};
  rows.forEach(row => {
    const key = row.teach_id || row.sub_id || (row.r_id + '-' + row.sub_id);
    if (!map[key]) {
      map[key] = {
        ...row,
        times: []
      };
    }
    map[key].times.push({
      teach_day: row.teach_day,
      period_order: row.period_order,
      period_begin: row.period_begin,
      period_end: row.period_end
    });
  });
  // ลบ field ที่ซ้ำ
  return Object.values(map).map(item => {
    delete item.teach_day;
    delete item.period_order;
    delete item.period_begin;
    delete item.period_end;
    return item;
  });
}

// ฟังก์ชันแปลงเวลาเป็นรูปแบบ HH:MM
export function formatTimeShort(timeStr) {
  // รับ "08:00:00" คืน "08:00"
  if (!timeStr) return "";
  return timeStr.slice(0, 5);
}

// ภาคเรียนปัจจุบันโดยประมาณจากเดือน (พ.ค.–ต.ค. = เทอม 1, ที่เหลือ = เทอม 2)
// เผื่อช่วงปลายเทอม 1 ให้ครูใส่คะแนนได้ จึงรวมเดือน ต.ค. ไว้ในเทอม 1 คืนค่าเป็น string '1' / '2'
export function getCurrentSemester(date = new Date()) {
  const m = date.getMonth() + 1;
  return m >= 5 && m <= 10 ? '1' : '2';
}

// ลำดับการแสดงภาคเรียน โดยให้ภาคเรียนปัจจุบันขึ้นก่อน เช่น ['2','1'] ถ้าตอนนี้เป็นเทอม 2
export function getSemesterOrder(date = new Date()) {
  return getCurrentSemester(date) === '2' ? ['2', '1'] : ['1', '2'];
}

// นักเรียนที่ลาออก (st_status = 0) หรือย้ายห้อง (tb_study.transfer_room_id)
// ยังอยู่ในรายชื่อห้องเดิม แต่ไม่ต้องกรอก/แก้ไขคะแนนในห้องนี้
export const isWithdrawn = (st) => String(st.st_status) === '0';
export const isTransferred = (st) => st.transfer_room_id != null;
export const isInactive = (st) => isWithdrawn(st) || isTransferred(st);

export function inactiveLabel(st) {
  if (isWithdrawn(st)) return 'ลาออก';
  return st.transfer_c_id != null
    ? `ย้ายห้อง → ม.${st.transfer_c_id}/${st.transfer_r_no}`
    : 'ย้ายห้อง';
}

// g_grade เก็บคะแนนดิบ (0-100); calculateGrade แปลงเป็นเกรด 0-4
export const GRADE_THRESHOLDS = [
  { min: 80, grade: 4 },
  { min: 75, grade: 3.5 },
  { min: 70, grade: 3 },
  { min: 65, grade: 2.5 },
  { min: 60, grade: 2 },
  { min: 55, grade: 1.5 },
  { min: 50, grade: 1 },
  { min: 0,  grade: 0 },
];

export function calculateGrade(score) {
  if (score === null || score === undefined || score === '') return null;
  const s = parseFloat(score);
  if (isNaN(s)) return null;
  for (const t of GRADE_THRESHOLDS) {
    if (s >= t.min) return t.grade;
  }
  return 0;
}